import React, { useMemo, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faTrashCan,
} from "@fortawesome/free-solid-svg-icons";

import AsyncSelect from 'util/component/SearchableSelect/async'

import ModalPortal from "util/component/Modal";
import {ConfirmWithMessage, Modal} from "util/component/Modal/Modal";

import { useSelector, useDispatch } from "react-redux";
import axios from 'util/axios';
import {useTranslation} from "react-i18next";

const MatchTable = (props, ref) => {
    const { sheets, descs } = props;
    const [ SelectedUser , setSelectedUser ] = useState(null);
    const [ConfirmDom, SetConfirmDom] = useState(null);
    const { t } = useTranslation(["page"]);
    const userSelector = useSelector((store) => store.user);
    const dispatch = useDispatch();

    const renderSheet = useMemo(() => {
        const render = sheets?.list?.map((rowData,i) => {
            return <tr key={`renderItem${i}`}>
                
                <td className={"text-left"}>
                    {rowData.info}
                </td>
                <td>
                    {rowData.type}
                </td>
                <td className={"clickable"} onClick={() => {
                    sheets?.set(OLD => ([...OLD.filter(e => e.sheetCode !== rowData.sheetCode)]))
                }}>
                    <FontAwesomeIcon icon={faTrashCan} color={"red"} />
                </td>
            </tr>
        })
        return render;
    }, [sheets]);

    const renderDesc = useMemo(() => {
        const render = descs?.list?.map((rowData,i) => {
            return <tr key={`renderItem${i}`}>
                <td className={"text-left"}>
                    {rowData.info}
                </td>
                <td>
                    {rowData.type}
                </td>
                <td className={"clickable"} onClick={() => {
                    descs?.set(OLD => ([...OLD.filter(e => e.descCode !== rowData.descCode)]))
                }}>
                    <FontAwesomeIcon icon={faTrashCan} color={"red"} />
                </td>
            </tr>
        })
        return render;
    },[descs])

    const changeConfirm = async (memo) => {
        dispatch({type: "LOADING_ON"});
        const userId = userSelector.userId;
        const ownerId = SelectedUser;
        try {
            let postData = {
                userId,
                memo,
                message: memo
            };
            let response;
            postData.sheet = sheets.list.map(rowData => {
                const {sheetCode, tempYn, revision,projectNm,mbrNo,processCd,beforeOwnerId} = rowData
                return {sheetCode, tempYn, revision,projectNm,mbrNo,processCd, userId,beforeOwnerId, ownerId, memo, message: memo}
            })
            if(postData.sheet.length > 0) {
                response = await axios.post(process.env.REACT_APP_API + "/pcsModify/modifySheetOwner", postData)

                if(response.data.data.result === "ERR110") {
                    SetConfirmDom(<Modal onClose={() => SetConfirmDom(null)}>{t("ERR110")}</Modal>);
                }else{
                    window.location.reload();
                }
            }

            postData = {
                userId,
                memo,
                message: memo
            };

            postData.desc = descs.list.map(rowData => {
                const {descCode, tempYn, revision,projectNm,processCd,beforeOwnerId} = rowData
                return {descCode, tempYn, revision,projectNm,processCd, userId,beforeOwnerId, ownerId, memo, message: memo}
            })
            if(postData.desc.length > 0) {
                response = await axios.post(process.env.REACT_APP_API + "/pcsDesc/modifyDescOwner", postData)
                if(response.data.data.result === "ERR110") {
                    SetConfirmDom(<Modal onClose={() => SetConfirmDom(null)}>{t("ERR110")}</Modal>);
                }else{
                    window.location.reload();
                }
            }

        } catch(e) {
            console.error(e);
        } finally {
            dispatch({type: "LOADING_OFF"});
        }

    }

    const HandleChange = () => {
        const confirmDom = (
            <ConfirmWithMessage
                onClose={() => SetConfirmDom(null)}
                message={"Owner change"}
                onConfirm={(msg) => changeConfirm(msg)}
            ></ConfirmWithMessage>
        );
        SetConfirmDom(confirmDom);
    }

    return (
        <>
        
        <table className={"bpl-table-default small fixed text-center matching-table"}>
            <colgroup>
                <col />
                <col width="80" />
                <col width="30" />
            </colgroup>
            <thead>
                <tr>
                    <th>Information</th>
                    <th>Type</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>{renderSheet}{renderDesc}</tbody>
            <tfoot>
                <tr>
                    <td>
                        <AsyncSelect
                            api="/user/retrieveUserListForSearch"
                            onChange={(selected) => {setSelectedUser(selected.value)}}
                            value={SelectedUser}
                            border={"ON"}
                            body={{ authCode: [{value:"2"}]}}
                        />
                    </td>
                    <td colSpan={2}>
                        <button className={"bpl-btn success"}
                            disabled={(!SelectedUser || !(sheets.list?.length + descs.list.length) > 0)}
                            onClick={HandleChange}
                        >Change</button>
                    </td>
                </tr>
            </tfoot>
        </table>
        {ConfirmDom && <ModalPortal>{ConfirmDom}</ModalPortal>}
        </>
    );
};

export default MatchTable;
